import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NodeDialogInf} from '../nodes-dialog/nodes-dialog.component';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';

@Component({
  selector: 'nodes-third-party-dialog',
  templateUrl: './nodes-third-party-dialog.component.html',
  styleUrls: ['./nodes-third-party-dialog.component.scss']
})
export class NodesThirdPartyDialogComponent implements OnInit {

  onApply = new EventEmitter();
  onCancel = new EventEmitter();
  isAuthorized: boolean;

  constructor(public dialogRef: MatDialogRef<NodeDialogInf>,
              @Inject(MAT_DIALOG_DATA) public data: NodeDialogInf,
              private userPrivilege: UserPrivilegeService) {
  }

  ngOnInit(): void {
    this.isAuthorized = this.userPrivilege.isAuthorized();

    if (!this.data.isEditMode) {
      this.data.selectedItem.routingInterfaces = [{internalId: 1, tcpPort: 5060, udpPort: 5060, tlsPort: 5061}];
    }
  }

  cancel(): void {
    this.dialogRef.close();
    this.onCancel.emit();
  }

  submit(): void {
    this.onApply.emit(this.data);
  }

  removeRoutingInterface(index: number): void {
    this.data.selectedItem.routingInterfaces.splice(index, 1);
  }

  addRoutingInterface(): void {
    this.data.selectedItem.routingInterfaces.push({tcpPort: 5060, udpPort: 5060, tlsPort: 5061});
  }
}
